import WidgetWrapper from '@/js/shared/components/widgets/WidgetWrapper';
import { AuthContext, ConferenceContext, VideoChatContext } from '@/store';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
import { Box, Button, Icon } from '@mui/material';
import React, { useContext } from 'react';
import { IContent } from './contract';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles = ({ override }: { override: Record<string, any> }) => ({
  root: {
    textAlign: 'center !important',
    ...override.root,
  },
  button: {
    ...override.button,
  },
  image: {
    width: '160px !important',
    height: 'auto !important',
    ...override.button,
  },
});

export const Render = ({
  node: {
    id,
    content: { label, call, description },
    override,
  },
  conferenceId,
}: IProps) => {
  const classes = useStyles({ override });

  const { handleSendInvitation } = useContext(VideoChatContext); // Hämta Context
  const { openUserPopup } = useContext(ConferenceContext); // Hämta Context
  const { authState } = useContext(AuthContext); // Hämta Context

  const functionCall = (func) => {
    switch (func) {
      case 'videochat': {
        return handleSendInvitation();
      }
      case 'profile': {
        return openUserPopup(authState.user);
      }
    }
  };

  return (
    <WidgetWrapper>
      <Box sx={classes.root}>
        {call === 'videochat' && (
          <div>
            <Box
              component="img"
              sx={classes.image}
              src="/images/watch-together.jpg"
            />
          </div>
        )}

        <Button
          {...useNodeProps(id)}
          sx={classes.button}
          variant="contained"
          color="primary"
          size="small"
          startIcon={
            call === 'videochat' ? (
              <Icon>videocam</Icon>
            ) : call === 'profile' ? (
              <Icon>person</Icon>
            ) : null
          }
          onClick={() => functionCall(call)}
        >
          {label}
        </Button>
        {description && <div>{description}</div>}
      </Box>
    </WidgetWrapper>
  );
};
